// Press Sheet rolls listed on /newsletter, newest first. Each slug is a generated
// static page in public/newsletter/ (pnpm newsletter:web <slug>, see newsletter/README.md).
// `image` is the issue's hero photo on the CDN, shown on the newsletter tile for the latest roll.
const NEWSLETTER_ISSUES = [
  {
    slug: 'press-sheet-roll-01',
    roll: '01',
    month: 'October 2026',
    title: 'Start with a person. Find their photo.',
    theme: 'Photo gifts',
    image: { imageKey: 'display', prefix: 'categories/' },
  },
];

export const issueUrl = (issue) => `/newsletter/${issue.slug}.html`;

export default NEWSLETTER_ISSUES;
